<!-- f r o m 7 5  2 7 1  8 9 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入名称查询" v-model="queryParam.supplier"></a-input>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入手机号码查询" v-model="queryParam.telephone"></a-input>
                </a-form-item>
              </a-col> -->
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入联系电话查询" v-model="queryParam.phonenum"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <!-- <a-button style="margin-left: 8px" @click="ceshi">测试接口</a-button> -->
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <!-- <a-button @click="accountModel" type="primary" icon="plus">账号信息</a-button> -->
          <!-- <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleImportXls()" type="primary" icon="import">导入</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls('经销商信息')">导出</a-button>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
              <a-menu-item key="2" @click="batchSetStatus(true)"><a-icon type="check-square" />启用</a-menu-item>
              <a-menu-item key="3" @click="batchSetStatus(false)"><a-icon type="close-square" />禁用</a-menu-item>
            </a-menu>
            <a-button>
              批量操作 <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '2%' }"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
              <!-- <a-divider type="vertical" /> -->
              <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm> -->
              <a-divider type="vertical" />
              <a @click="accountModel(record)">账号信息</a>
              <a-divider type="vertical" />
              <!-- <a v-if="record.isOpenTransshipment" @click="handlechanneling(record)">防窜货配置</a> -->
              <a @click="handlechanneling(record)">添加主营区域</a>
              <a-divider type="vertical" />

              <a @click="handleArea(record)">主营区域</a>
            </span>
            <!-- 状态渲染模板 -->
            <template slot="isfch" slot-scope="text, record">
              <a-switch v-model="record.isOpenTransshipment" @change="change(record)" checked-children="是"
                un-checked-children="否" />
              <!-- <a-tag v-if="isOpenTransshipment==1" color="green">是</a-tag> -->
              <!-- <a-tag v-if="isOpenTransshipment==0" color="orange">否</a-tag> -->
            </template>
            <template slot="level" slot-scope="levelRegulation">
              <a-tag v-if="levelRegulation == 3" color="green">全国</a-tag>
              <a-tag v-if="levelRegulation == 0" color="orange">省</a-tag>
              <a-tag v-if="levelRegulation == 1" color="orange">市</a-tag>
              <a-tag v-if="levelRegulation == 2" color="orange">区</a-tag>
            </template>
            <template slot="orgName" slot-scope="orgName">
              <span v-if="orgName == 1">一级经销商</span>
              <span v-if="orgName == 2">二级经销商</span>
              <span v-if="orgName == 3">三级经销商</span>
            </template>
            <template slot="customRenderFlag" slot-scope="enabled">
              <a-tag v-if="enabled" color="green">启用</a-tag>
              <a-tag v-if="!enabled" color="orange">禁用</a-tag>
            </template>
            <template slot="locationName" slot-scope="text, record">
              <span v-if="!record.locationName">全国</span>
              <span v-else>{{ record.locationName }}</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <dealerModel ref="modalForm" @ok="modalFormOk"></dealerModel>
        <newAccountModel ref="newAccountModelref" @ok="modalFormOk"></newAccountModel>
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
        <userinfoModel ref="userinfoModel" @ok="modalFormOk"></userinfoModel>
        <useraddModel ref="useraddModel" @ok="modalFormOk"></useraddModel>
        <MainareaModel ref="MainareaModel" @ok="modalFormOk"></MainareaModel>
        <AreadetailModel ref="AreadetailModel" @ok="modalFormOk"></AreadetailModel>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- BY cao_yu_li -->
<script>
import dealerModel from './modules/dealerModel'
import newAccountModel from './modules/newAccountModel'
import MainareaModel from './modules/MainareaModel'
import userinfoModel from './modules/userinfoModel.vue'
import AreadetailModel from './modules/AreadetailModel.vue'
import useraddModel from './modules/useraddModel.vue'
import ImportFileModal from '@/components/tools/ImportFileModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDate from '@/components/jeecg/JDate'
import { getUser, editSupplier, accumulate } from '@/api/api.js'
export default {
  name: 'dealerList',
  mixins: [JeecgListMixin],
  components: {
    newAccountModel,
    userinfoModel,
    useraddModel,
    AreadetailModel,
    MainareaModel,
    dealerModel,
    ImportFileModal,
    JDate,
  },
  data () {
    return {
      checked: false,
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {
        supplier: '',
        type: '经销商',
        telephone: '',
        phonenum: '',
        userId: this.$store.getters.userInfo.id,
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 30,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
        { title: '名称', dataIndex: 'supplier', width: 150, align: 'left' },
        { title: '上级经销商名称', dataIndex: 'parentName', width: 150, align: 'left' },

        {
          title: '经销商类型',
          dataIndex: 'orgaId',
          width: 150,
          align: 'left',
          scopedSlots: { customRender: 'orgName' },
        },
        // {
        //   title: '是否开启防窜货配置',
        //   dataIndex: 'isOpenTransshipment',
        //   width: 150,
        //   align: 'left',
        //   scopedSlots: { customRender: 'isfch' },
        // },
        {
          title: '主营区域',
          dataIndex: 'locationName',
          width: 150,
          align: 'left',
          scopedSlots: { customRender: 'locationName' },
        },
        // {
        //   title: '监管级别',
        //   dataIndex: 'levelRegulation',
        //   width: 150,
        //   align: 'left',
        //   scopedSlots: { customRender: 'level' },
        // },

        // { title: '联系人', dataIndex: 'contacts', width: 70, align: 'left' },
        // { title: '手机号码', dataIndex: 'telephone', width: 100, align: 'left' },
        // { title: '联系电话', dataIndex: 'phoneNum', width: 100, align: 'left' },
        // { title: '电子邮箱', dataIndex: 'email', width: 150, align: 'left' },
        // { title: '期初应收', dataIndex: 'beginNeedGet', width: 80, align: 'left' },
        // { title: '期末应收', dataIndex: 'allNeedGet', width: 80, align: 'left' },
        // { title: '税率(%)', dataIndex: 'taxRate', width: 80, align: 'left' },
        // { title: '排序', dataIndex: 'sort', width: 60, align: 'left' },
        // {
        //   title: '状态',
        //   dataIndex: 'enabled',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
      url: {
        list: '/supplier/list',
        delete: '/supplier/delete',
        deleteBatch: '/supplier/deleteBatch',
        importExcelUrl: '/supplier/importCustomer',
        exportXlsUrl: '/supplier/exportExcel',
        batchSetStatusUrl: '/supplier/batchSetStatus',
      },
    }
  },
  created () {
    console.log(this.columns, 'columns')
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    ceshi () {
      let params = {
        search: {},
        currentPage: 1,
        pageSize: 10,
      }
      accumulate(params)
    },
    // 账号信息
    accountModel (record) {
      this.$refs.newAccountModelref.add(record)
    },
    async change (record) {
      console.log(record, 'record')
      let params = {
        id: record.id,
        isOpenTransshipment: record.isOpenTransshipment ? '1' : '0',
      }
      console.log(params, 'params')
      const res = await editSupplier(params)
      console.log(res, 'res')
    },
    // 查看主营区域
    handleArea (record) {
      this.$refs.AreadetailModel.add(record)
    },
    // 添加主营区域
    handlechanneling (record) {
      // this.$refs.AntiModel.add(record)
      this.$refs.MainareaModel.add(record)
    },
    async handleUser (record) {
      let obj = {
        userId: record.id,
        currentPage: 1,
        pageSize: 10,
      }
      const res = await getUser(obj)
      if (res.code == 200) {
        console.log(res, 'res')
        let list = []
        list.push(res.data.user)
        if (list.length > 0) {
          this.$refs.userinfoModel.add(list)
        } else {
          console.log(record, '11')
          this.$refs.useraddModel.add(record)
        }
      } else {
        this.$message.error(res.msg || res.data)
      }
    },
    searchReset () {
      this.queryParam = {
        supplier: '',
        type: '经销商',
        telephone: '',
        phonenum: '',
        userId: this.$store.getters.userInfo.id,
      }
      this.loadData(1)
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/customer_template.xls'
      let templateName = '客户Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '客户导入'
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
  },
}
</script>
<style scoped>@import '~@assets/less/common.less';</style>